<notifier-container></notifier-container>
<input type="hidden" id="pathFile" [(ngModel)]="pathFile">
<div class="scope_title">
  <h3>{{ processModel?.policyName }}</h3>
</div>

<div *ngIf="!onPrint" class="scope">
  <!-- coluna esquerda - timeline/opções -->
  <div class="col-timeline"  [class.timeline-open]="timelineOpened">

    <div *ngIf="showLeftBoard" class="card">

      <!-- timeline -->
      <div *ngIf="showTimeline" class="timeline__container">

        <div [ngClass]="[getStepClass(stepAttr), 'timeline__item']" *ngFor="let stepAttr of timeline; let index = index" >

          <div class="timeline__parent">
            <div class="timeline__parent-icon">
                <i class="fas"></i>
            </div>
            <a href="#" (click)="preventDefaultLink($event)">{{stepAttr.value}}</a>
          </div>

          <div [ngClass]="[getStepClass(childAttr), 'timeline__child']" *ngFor="let childAttr of stepAttr.attributes">
            <div class="timeline__child-icon">
              <i class="fas"></i>
            </div>
            <a href="#" (click)="preventDefaultLink($event)">{{childAttr.value}}</a>

          </div>
        </div>
      </div>

      <!-- btn expandir timeline mobile -->
      <button class="btn-timeline-mobile" [class.timeline-open]="!timelineOpened" (click)="timelineOpened = !timelineOpened"><i class="fas"></i></button>

      <!-- ações do projeto -->
      <div class="options__container">
        <ul>
          <li *ngIf="showHistoryButton">
            <button data-target="#history" data-toggle="modal" >
              <span> <i class="fa fa-history"></i> Histórico</span>
              <i class="fa fa-angle-right"></i>
            </button>
          </li>
          <li *ngIf="hasCommentProperty">
            <button data-target="#parecer" data-toggle="modal">
              <span><i class="fa fa-comments"></i> Comentar</span>
              <i class="fa fa-angle-right"></i>
            </button>
          </li>
          <li *ngIf="showPrintButton">
            <button href="javascript:;" (click)="print()">
              <span><i class="fa fa-print"></i> Imprimir</span>
              <i class="fa fa-angle-right"></i>
            </button>
          </li>
          <li *ngIf="showDeleteButton">
            <button (click)="onDelete()">
              <span><i class="fa fa-trash"></i> Excluir</span>
              <i class="fa fa-angle-right"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- coluna escopo -->
  <div class="col-scope">

    <div class="card">

      <!-- tabs -->
      <ul class="nav" role="tablist">
        <li *ngFor="let attribute of getSections() ; let index = index" class="nav-item">
          <a class="nav-link " [class.active]="attribute.isActive" data-toggle="tab"
            (click)="selectTab(attribute.key)"
            [href]="'#'+getKey(attribute.key)">
            {{ getTitle(attribute) }}
          </a>
        </li>
      </ul>

      <!-- content -->
      <div class="tab-content">
        <div *ngFor="let attribute of getSections(); let index = index" class="tab-pane " [class.active]="attribute.isActive"
          [id]="getKey(attribute.key)" role="tabpanel">
          <app-section
            [attribute]="attribute"
            [envOptions]="getEnvOptions()"
            (executionRequest)="onExecuteRequest($event)"
            (onEmit)="onSectionEmit($event)">
          </app-section>
        </div>
      </div>

      <!-- historico de versões -->
      <div class="dropdown version"  *ngIf="hasVersions()">
        <button class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Versões
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <ul>
            <li>
              <a href="javascript:;" (click)="onChangeToCurrent()">
                Versão atual
              </a>
            </li>
            <li *ngFor="let attr of versions">
              <a href="javascript:;" (click)="onChangeVersion(attr)">
                {{ attr.key }} - {{ attr.value | date: 'dd/MM/yyyy HH:mm' }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- botões de ações -->
      <div class="button-tasks">
        <app-task *ngFor="let task of getTasksOfCurrentStep()"
          class="task"
          [task]="task"
          (onExecute)="execute($event)">
        </app-task>

        <app-button-link *ngFor="let button of getButtonsFromCurrentStep()"
          class="task"
          [button]="button">
        </app-button-link>
      </div>
    </div>
  </div>
</div>

<div *ngIf="onPrint" class="d-none d-print-block">

  <div *ngFor="let attribute of getSections(); let index = index" class="tab-pane"
    [id]="getKey(attribute.key) + '_2'" style="page-break-after: always;">

    <h2 style="margin-top: 80px" class="text-center">{{attribute.key}}</h2>
    <hr>

    <app-section
      [viewMode]="getViewModeOption(attribute)"
      [attribute]="attribute"
      [envOptions]="getEnvOptionsForPrint()">
    </app-section>
  </div>

  <div class="tab-pane" >
      <h2 style="margin-top: 80px" class="text-center">Histórico</h2>
      <hr>

    <div class="approval">
      <p>Fase atual:</p>
      <h1>{{ getCurrentStepName() }}</h1>
    </div>

  </div>
</div>


<!-- Modal Comentário -->
<div *ngIf="hasCommentProperty" class="modal fade" id="parecer" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Qual é o seu comentário?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-form__group m-comment-mic">

              <div class="loading hide">
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
              </div>


              <textarea
                class="form-control m-input m-input--air txtComment txtarea"
                (keypress)="onMaxlength($event)"
                id="txtComment"
                rows="3"
                [(ngModel)]="comment.value"
                [maxlength]="commentMaxlength"
                placeholder="Escreva seu comentário"
                value="teste">
              </textarea>
            </div>
            <div class="form-group m-form__group">
              <ng-select [items]="users" [addTag]="usersPromise" [hideSelected]="true" multiple="true" bindLabel="name"
                placeholder="Deseja marcar pessoas?" [(ngModel)]="selectedUsers">
              </ng-select>
            </div>
            <div class="col-md-12"><span class="'m-form__error hide has-error-text">Campo obrigatório</span></div>
          </div>
        </div>
        <div class="text-center">
          <a href="javascript:;" class="btn btn-primary m-btn--custom" (click)="sendComment()">Salvar
            Comentário</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Parecer -->
<div class="modal fade modal-project parecer parecerAR" id="parecerAR" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">{{ getTitleModal() }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="m-form__group m-comment-mic">
              <div class="loading hide">
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
              </div>

              <textarea *ngIf="hasInputText()" 
                id="actionComment" 
                class="form-control"
                [(ngModel)]="taskComment.value"
                [style]="{height: '200px'}" 
                [placeholder]="getOptionValueByKey(taskComment,'placeholder')"
                (keypress)="onMaxlength($event)">
              </textarea>
            </div>
          </div>
          <div class="col-md-12 text-center">
              <span class="'m-form__error hide has-error-text">Campo obrigatório</span>
            <br>
          </div>

          <div class="col-md-3 text-center" *ngIf="hasParecer()">
              <button class="btn btn-success m-btn--custom s" (click)="sendTask()">
               <i class="fa fa-check"></i> APROVAR
              </button>
          </div>
          <div class="col-md-6 text-center" *ngIf="hasParecer()">
              <button class="btn m-btn--custom r" (click)="sendTask()">APROVAR COM RESSALVAS</button>
          </div>
          <div class="col-md-3 text-center" *ngIf="hasParecer()">
              <button class="btn btn-danger m-btn--custom n" (click)="sendTask()">
                  <i class="fa fa-close"></i> REPROVAR
              </button>
          </div>

          <div class="col-md-12 text-center" *ngIf="!hasParecer()">
            <button class="btn btn-primary m-btn--custom" (click)="sendTask()"> Confirmar </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Histórico -->
<div class="modal fade history" id="history" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Histórico</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body history__container">
        <div class="history__item" *ngFor="let historyItem of getHistory(); let i = index">
          <h5 *ngIf="showStepName(i)" class="history__step" >{{getValueByKey(historyItem, 'Name')}}</h5>
          <span class="history__text">
            {{geKeyByType(historyItem,'Task',': ')}}
            {{geKeyByType(historyItem,'InputText',': ')}}
            {{geKeyByType(historyItem,'ActionButton',': ')}}
            {{geKeyByType(historyItem,'ActionToggle',': ')}}
            {{geKeyByType(historyItem,'ActionText',': ')}}
            {{getValueByKey(getAttributeByKey(getAttributeByType(historyItem,'Task'),'User'),'Name')}}
            {{getValueByKey(getAttributeByKey(getAttributeByType(historyItem,'InputText'),'User'),'Name')}}
            {{getValueByKey(getAttributeByKey(getAttributeByType(historyItem,'ActionButton'),'User'),'Name')}}
            {{getValueByKey(getAttributeByKey(getAttributeByType(historyItem,'ActionToggle'),'User'),'Name')}}
            {{getValueByKey(getAttributeByKey(getAttributeByType(historyItem,'ActionText'),'User'),'Name')}}
          </span>
          <span class="history__date">{{ngConverDate(historyItem.value)}}</span>
          <div *ngFor="let comment of getComments(historyItem)" class="history__comment">
            <p [innerHTML]="formatHtml(getTitleRecipient(comment))"
              [innerHTML]="formatHtml(comment.value)">
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





